var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.saleType.Name.getTranslation(_vm.locale)) +
            " " +
            _vm._s(_vm.$ct("settings-subtitle"))
        ),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-sale-layout", {
                    attrs: {
                      id: "",
                      label: _vm.$ct("layout-default"),
                      fancy: "",
                      "contact-group-id": _vm.saleType.ContactGroupID,
                    },
                    model: {
                      value: _vm.config.DefaultLayoutID,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultLayoutID", $$v)
                      },
                      expression: "config.DefaultLayoutID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-sale-layout", {
                    attrs: {
                      id: "",
                      label: _vm.$ct("layout-default-second-hand"),
                      fancy: "",
                      "contact-group-id": _vm.saleType.ContactGroupID,
                    },
                    model: {
                      value: _vm.config.DefaultLayoutSecondHandSaleVatRegime,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config,
                          "DefaultLayoutSecondHandSaleVatRegime",
                          $$v
                        )
                      },
                      expression: "config.DefaultLayoutSecondHandSaleVatRegime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "", center: "" } },
                    [
                      _c("w-multi-select", {
                        style: { flexGrow: 1 },
                        attrs: {
                          items: _vm.saleLayoutIdItems,
                          "empty-text": _vm.$ct("use-default-layout"),
                          label: _vm.$ct("layout-default-print"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.config.DefaultPrintLayoutIDs,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "DefaultPrintLayoutIDs", $$v)
                          },
                          expression: "config.DefaultPrintLayoutIDs",
                        },
                      }),
                      _c(
                        "w-link",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value:
                                _vm.toggleUserDefaultPrintLayoutOverrideTooltip,
                              expression:
                                "toggleUserDefaultPrintLayoutOverrideTooltip",
                            },
                          ],
                          staticClass: "ml mr",
                          style: { flexShrink: 0 },
                          on: {
                            click: function ($event) {
                              return _vm.toggleUserDefaultPrintLayoutOverride()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: {
                              size: "lg",
                              icon: _vm.userDefaultPrintLayoutOverrideIcon,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-transition-slide-height",
                [
                  _vm.userDefaultPrintLayoutOverrideShown
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-multi-select", {
                            style: { flexGrow: 1 },
                            attrs: {
                              items: _vm.saleLayoutIdItems,
                              "empty-text": _vm.$ct("use-default-layout"),
                              label: _vm.$ct("layout-default-print-user"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.userConfig.DefaultPrintLayoutIDs,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.userConfig,
                                  "DefaultPrintLayoutIDs",
                                  $$v
                                )
                              },
                              expression: "userConfig.DefaultPrintLayoutIDs",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-multi-select", {
                    attrs: {
                      items: _vm.saleLayoutIdItems,
                      "empty-text": _vm.$ct("use-default-layout"),
                      label: _vm.$ct("layout-default-send"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.config.DefaultSendLayoutIDs,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DefaultSendLayoutIDs", $$v)
                      },
                      expression: "config.DefaultSendLayoutIDs",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-multi-select", {
                    attrs: {
                      "empty-text": _vm.$ct("common.none"),
                      items: _vm.saleLayoutIdItems,
                      label: _vm.$ct("extra-available-layouts"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.config.AvailableLayoutIDs,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "AvailableLayoutIDs", $$v)
                      },
                      expression: "config.AvailableLayoutIDs",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-language-select", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("override-layout-language"),
                      "add-empty-option": "",
                      "empty-option-text": _vm.$ct("use-document-language"),
                    },
                    model: {
                      value: _vm.config.LangOverride,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "LangOverride", $$v)
                      },
                      expression: "config.LangOverride",
                    },
                  }),
                ],
                1
              ),
              _vm.isElectron
                ? _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-electron-directory-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("default-download-location"),
                          value: _vm.electronDefaultDownloadLocation,
                          "show-remove-button": "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setElectronDefaultDownloadLocation(
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-col",
                {
                  style: { display: "flex", flexDirection: "row" },
                  attrs: { xs: "12" },
                },
                [
                  _c("app-contact-search", {
                    style: { flexGrow: 1, marginBottom: "0" },
                    attrs: {
                      value: _vm.defaultContact,
                      label: _vm.$ct("default-contact"),
                      fancy: "",
                      "disable-create": "",
                      icon: "times",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.selectDefaultContact($event)
                      },
                      "icon-click": function ($event) {
                        return _vm.clearDefaultContact()
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                {
                  style: { display: "flex", flexDirection: "row" },
                  attrs: { xs: "12" },
                },
                [
                  _c("app-contact-search", {
                    style: { flexGrow: 1, marginBottom: "0" },
                    attrs: {
                      label: _vm.$ct("default-contact-for-new-document"),
                      fancy: "",
                      "disable-create": "",
                      value: _vm.defaultContactForNewDocument,
                      icon: "times",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.selectContactForNewDocument($event)
                      },
                      "icon-click": function ($event) {
                        return _vm.clearDefaultContactForNewDocument()
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "12", xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("stock-compute") },
                    model: {
                      value: _vm.config.ComputeStock,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "ComputeStock", $$v)
                      },
                      expression: "config.ComputeStock",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("use-tracking-numbers") },
                    model: {
                      value: _vm.config.UseProductTrackingNumbers,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "UseProductTrackingNumbers", $$v)
                      },
                      expression: "config.UseProductTrackingNumbers",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      value: !_vm.config.DontAddProductComposition,
                      label: _vm.$ct("add-product-composition-rows"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.config.DontAddProductComposition = !$event
                      },
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      value: _vm.dontCopyBackordersToNewYear,
                      disabled: _vm.dontCopyBackordersToNewYearDisabled,
                      label: _vm.$ct("dont-copy-backorders-to-new-bookyear"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.config.DontCopyBackordersToNewBookyear = $event
                      },
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("new-sale-on-close") },
                    model: {
                      value: _vm.userConfig.NewSaleOnClose,
                      callback: function ($$v) {
                        _vm.$set(_vm.userConfig, "NewSaleOnClose", $$v)
                      },
                      expression: "userConfig.NewSaleOnClose",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("open-ev-new-sale") },
                    model: {
                      value: _vm.config.OpenExtraFields,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "OpenExtraFields", $$v)
                      },
                      expression: "config.OpenExtraFields",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("ask-for-bank-transfer") },
                    model: {
                      value: _vm.config.AskforBankTransfer,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "AskforBankTransfer", $$v)
                      },
                      expression: "config.AskforBankTransfer",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      disabled: !_vm.config.AskforBankTransfer,
                      label: _vm.$ct("ask-for-bank-transfer-default-on"),
                    },
                    model: {
                      value: _vm.config.AskforBankTransferDefaultOn,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "AskforBankTransferDefaultOn", $$v)
                      },
                      expression: "config.AskforBankTransferDefaultOn",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("show-ticket-refund") },
                    model: {
                      value: _vm.config.ShowTicketRefundDisplay,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "ShowTicketRefundDisplay", $$v)
                      },
                      expression: "config.ShowTicketRefundDisplay",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("prevent-ev-import") },
                    model: {
                      value: _vm.config.PreventCopyOfEvWhileImporting,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config,
                          "PreventCopyOfEvWhileImporting",
                          $$v
                        )
                      },
                      expression: "config.PreventCopyOfEvWhileImporting",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      disabled: !_vm.hasCarModule,
                      label: _vm.$ct("open-car-select-modal-on-new-sale"),
                    },
                    model: {
                      value: _vm.userConfig.OpenCarSelectModalByDefault,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.userConfig,
                          "OpenCarSelectModalByDefault",
                          $$v
                        )
                      },
                      expression: "userConfig.OpenCarSelectModalByDefault",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      value: !_vm.userConfig.DontUseLeeggoed,
                      label: _vm.$ct("compute-leeggoed"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.userConfig.DontUseLeeggoed = !$event
                      },
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      disabled: !_vm.hasSignatureModule,
                      label: _vm.$ct("can-be-signed-by-the-customer"),
                    },
                    model: {
                      value: _vm.config.CanBeSignedByClient,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "CanBeSignedByClient", $$v)
                      },
                      expression: "config.CanBeSignedByClient",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("ask-for-extra-print-options-on-save"),
                    },
                    model: {
                      value: _vm.config.AskForExtraPrintOptionsOnSave,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.config,
                          "AskForExtraPrintOptionsOnSave",
                          $$v
                        )
                      },
                      expression: "config.AskForExtraPrintOptionsOnSave",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("ask-to-create-calendar-event") },
                    model: {
                      value: _vm.config.AskToCreateCalendarEvent,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "AskToCreateCalendarEvent", $$v)
                      },
                      expression: "config.AskToCreateCalendarEvent",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("dont-allow-delete") },
                    model: {
                      value: _vm.config.DontAllowDelete,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "DontAllowDelete", $$v)
                      },
                      expression: "config.DontAllowDelete",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("enable-expiration-days") },
                    model: {
                      value: _vm.config.EnableExpirationDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "EnableExpirationDays", $$v)
                      },
                      expression: "config.EnableExpirationDays",
                    },
                  }),
                  _vm.config.EnableExpirationDays
                    ? _c("w-input-number", {
                        attrs: {
                          decimals: "0",
                          label: _vm.$ct("days-until-expiration"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.config.DaysUntilExpiration,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "DaysUntilExpiration", $$v)
                          },
                          expression: "config.DaysUntilExpiration",
                        },
                      })
                    : _vm._e(),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("reduce-imported-sale-backorder") },
                    model: {
                      value: _vm.config.ReduceImportedSaleBackorder,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "ReduceImportedSaleBackorder", $$v)
                      },
                      expression: "config.ReduceImportedSaleBackorder",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("hide-sale-import-reference-row") },
                    model: {
                      value: _vm.config.HideSaleImportReferenceRows,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "HideSaleImportReferenceRows", $$v)
                      },
                      expression: "config.HideSaleImportReferenceRows",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("use-default-delivery-address") },
                    model: {
                      value: _vm.config.UseDefaultDeliveryAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "UseDefaultDeliveryAddress", $$v)
                      },
                      expression: "config.UseDefaultDeliveryAddress",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct(
                        "show-amount-delivered-field-when-editing"
                      ),
                    },
                    model: {
                      value: _vm.config.ShowAmountDeliveredField,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "ShowAmountDeliveredField", $$v)
                      },
                      expression: "config.ShowAmountDeliveredField",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }